export const parseNumericParam = (value: unknown): number | null => {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  if (typeof value !== "string") {
    return null;
  }

  const trimmed = value.trim();
  if (!trimmed) return null;

  const unquoted =
    trimmed.startsWith('"') && trimmed.endsWith('"') && trimmed.length >= 2
      ? trimmed.slice(1, -1)
      : trimmed;
  const parsed = Number(unquoted);
  return Number.isNaN(parsed) ? null : parsed;
};

export const parseFirstNumericParam = (
  ...values: Array<unknown>
): number | null => {
  for (const value of values) {
    const parsed = parseNumericParam(value);
    if (parsed !== null) return parsed;
  }
  return null;
};
